import React, { Component } from 'react'
import Store from './store'
import { observer } from 'mobx-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Radio,
  Button,
  DatePicker,
  InputNumber,
  Alert,
  Select,
  Switch,
  MagicInput
} from 'hljd'
import { toJS } from 'mobx'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'
import { getMerchantInfo } from '@util'
import { COUPONS_PATH } from '@constant'
import { Link } from 'react-router'
import UseCase from '../UseCase'

const Item = Form.Item
const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const RangePicker = DatePicker.RangePicker
const Option = Select.Option

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      routeParams: { id },
      location: { query }
    } = this.props
    this.store = new Store(id, query)
  }

  componentDidMount() {
    this.store.getProperties()
  }

  render() {
    const store = this.store
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    }
    const radioStyle = {
      display: 'block',
      height: '40px',
      lineHeight: '40px',
      marginBottom: '20px'
    }

    const radioOtherStyle = {
      display: 'block',
      height: '40px',
      lineHeight: '40px'
    }

    const {
      coupon_type,
      property_id,
      is_limit,
      value,
      type,
      money_sill,
      provide,
      valid,
      total_count,
      title,
      use_case,
      hidden,
      isEdit,
      id,
      valid_type,
      hiddenDisabled,
      propertiesList,
      valid_day
    } = store
    return (
      <HeaderView
        title={`${id ? '编辑' : '创建'}优惠券`}
        header={[
          <Link to={COUPONS_PATH}>优惠券</Link>,
          `${id ? '编辑' : '创建'}优惠券`
        ]}
      >
        {/* <p className={styles.title}>
          <a href={COUPONS_PATH_A}>优惠券 > </a>
          <span>{id ? '编辑' : '创建'}优惠券 </span>
        </p> */}

        <div className={styles.form} style={{ marginTop: 30 }}>
          <Form layout="horizontal">
            <Item>
              <RadioGroup
                style={{ marginLeft: '11%', display: 'block' }}
                value={coupon_type}
                onChange={store.changeField('coupon_type')}
                disabled={isEdit}
              >
                <RadioButton value="1">普通优惠券</RadioButton>
                <RadioButton value="2">特殊专享券</RadioButton>
              </RadioGroup>
              {coupon_type == '1' && (
                <Alert
                  message="普通优惠券会显示在店铺主页，线上所有用户均能领取使用。"
                  type="warning"
                  showIcon
                  style={{
                    marginTop: '10px',
                    marginLeft: '11%',
                    display: 'inline-block'
                  }}
                />
              )}

              {coupon_type == '2' && (
                <Alert
                  message="为非公开领取的优惠券，只有商家主动通过私信、直播等渠道发放给用户时可领取。通过对意向强烈用户发放专属优惠，击破新人最后的价格心理防线。"
                  type="warning"
                  showIcon
                  style={{
                    marginTop: '10px',
                    marginLeft: '11%',
                    display: 'inline-block'
                  }}
                />
              )}
            </Item>
            {coupon_type == '2' && (
              <Item label="优惠券备注" {...layout} required>
                <MagicInput
                  value={title}
                  style={{ width: 363 }}
                  maxLength={20}
                  showCount
                  countPosition="right"
                  onChange={store.changeField('title')}
                />
                <p>优惠券备注仅用于商家后台，不显示在婚礼纪APP中</p>
              </Item>
            )}
            {coupon_type == '1' && (
              <Item label="使用场景" {...layout} required>
                <UseCase
                  changeField={store.changeField}
                  use_case={use_case}
                  title={title}
                />
              </Item>
            )}
            <Item label="金额" {...layout} required>
              <InputNumber
                placeholder="正整数"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                precision={0}
                min={1}
                value={value}
                onChange={store.changeField('value')}
                style={{ width: 260 }}
                disabled={isEdit}
              />
              <span style={{ paddingLeft: 10 }}>
                元<i style={{ color: '#999' }}>（保存后不可更改）</i>
              </span>
            </Item>

            <Item label="使用条件" {...layout} required>
              <RadioGroup
                value={type + ''}
                onChange={store.changeField('type')}
                disabled={isEdit}
              >
                <Radio style={radioStyle} value={'1'}>
                  满减券：满
                  <InputNumber
                    placeholder="正整数"
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    precision={0}
                    min={0}
                    value={money_sill}
                    onChange={store.changeField('money_sill')}
                    style={{ width: 260, margin: '0 10px' }}
                    disabled={isEdit}
                  />
                  元使用
                </Radio>
                <Radio style={radioOtherStyle} value={'2'}>
                  无门槛：无使用金额限制（保存后不可更改）
                </Radio>
              </RadioGroup>
            </Item>

            {getMerchantInfo().is_franchisee == '1' && (
              <Item label="限制类目" {...layout} required>
                <Switch
                  checked={is_limit}
                  onChange={store.changeValue('is_limit')}
                  checkedChildren="限制"
                  unCheckedChildren="不限"
                  disabled={isEdit}
                />

                <span style={{ color: '#999', paddingLeft: 8 }}>
                  (保存后不可修改)
                </span>

                <div>
                  <span>仅限选中类目的套餐可用(可多选)</span>
                  <Select
                    mode="multiple"
                    style={{ width: 220, marginLeft: 8 }}
                    disabled={isEdit || !is_limit}
                    value={toJS(property_id)}
                    placeholder={'请选择'}
                    onChange={store.changeValue('property_id')}
                  >
                    {propertiesList.map(({ id, name }) => (
                      <Option value={id} key={id}>
                        {name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Item>
            )}

            {/* {coupon_type == '1' && (
              <Item label="领取条件" {...layout} required>
                <RadioGroup
                  value={condition_of_get + ''}
                  onChange={store.changeCondition_of_get}
                >
                  <Radio style={radioStyle} value={'0'}>
                    无
                  </Radio>
                  <Radio style={radioStyle} value={'1'}>
                    加入收藏可领取
                  </Radio>
                </RadioGroup>
              </Item>
            )} */}

            <Item label="领取时间" {...layout} required>
              <RangePicker
                value={toJS(provide)}
                onChange={store.changeField('provide')}
              />
            </Item>

            <Item label="有效期" {...layout} required>
              <RadioGroup
                value={valid_type + ''}
                onChange={store.changeField('valid_type')}
                disabled={isEdit}
              >
                <Radio style={radioStyle} value={'1'}>
                  按起止日期：
                  <RangePicker
                    value={toJS(valid)}
                    onChange={store.changeField('valid')}
                    disabled={isEdit}
                  />
                </Radio>
                <Radio style={radioOtherStyle} value={'2'}>
                  按有效时长： 领取后
                  <InputNumber
                    placeholder="正整数"
                    precision={0}
                    min={0}
                    value={valid_day}
                    onChange={store.changeField('valid_day')}
                    style={{ width: 260, margin: '0 10px' }}
                    disabled={isEdit}
                  />
                  天有效
                </Radio>
              </RadioGroup>
              {/*
              <RangePicker
                value={toJS(valid)}
                onChange={store.changeField('valid')}
                disabled={isEdit}
              /> */}
              {/* <p style={{ color: '#aaa' }}>
                有效期开始之前用户可以领取但不能使用，保存后不可更改
              </p> */}
            </Item>

            <Item
              label="发行量"
              {...layout}
              required
              style={{ marginBottom: '10px' }}
            >
              <InputNumber
                placeholder="正整数，需小于100,000"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                max={100000}
                min={0}
                precision={0}
                value={total_count}
                onChange={store.changeField('total_count')}
                style={{ width: 260 }}
              />
              <span style={{ paddingLeft: 10 }}>张</span>
              <p>保存后修改发行量时只能增加不能减少</p>
            </Item>

            <Item label="激活状态" {...layout} required>
              <RadioGroup
                style={{ lineHeight: '40px' }}
                value={hidden + ''}
                onChange={store.changeField('hidden')}
                disabled={hiddenDisabled}
              >
                <Radio value={'1'}>激活</Radio>
                <Radio value={'0'}>不激活</Radio>
              </RadioGroup>
            </Item>
            <div style={{ textAlign: 'center', margin: '60px 0' }}>
              <Button
                className="submit"
                type="primary"
                onClick={store.editCoupon}
              >
                保存
              </Button>
              <Button
                className="cancel"
                style={{ marginLeft: 20 }}
                onClick={store.cancel}
              >
                取消
              </Button>
            </div>
          </Form>
        </div>
      </HeaderView>
    )
  }
}
